<template>
  <SrpModal :isVisible="props.isVisible" @update:isVisible="isVisible => emit('update:isVisible', isVisible)">
    <template #content>
      <div
        :style="{
          opacity: isLoading ? '0.5' : '1',
          pointerEvents: isLoading ? 'none' : 'auto',
        }"
      >
        <h1 class="global-h1" style="margin-bottom: 20px">Create Calendar Input</h1>

        <input class="global-text-input" type="text" placeholder="Date or season" v-model="date" style="max-width: 300px; margin-bottom: 15px" />

        <input class="global-text-input" type="text" placeholder="Name" v-model="title" style="max-width: 300px; margin-bottom: 15px" />

        <textarea class="global-textarea" placeholder="Description (optional)" v-model="description" style="height: 100px; min-height: 100px"></textarea>
      </div>
    </template>

    <template #footer="{ closeModal }">
      <SrpButton @click="createInput(closeModal)" :isDisabled="isLoading || !date || !title">
        <template v-if="isLoading" #icon><LoadingIcon :size="18" /></template>
        Create
      </SrpButton>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import ContentCalendarRepo from "@repos/ContentCalendarRepo";

// Components
import SrpModal from "@components/ui/SrpModal.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import LoadingIcon from "@components/ui/LoadingIcon.vue";

// Types
import { ContentCalendarInput, ContentCalendarInputSource, CreateContentCalendarInputRequest } from "@contracts/contentCalendar";

// Router
import { useRoute } from "vue-router";
const route = useRoute();

const props = withDefaults(
  defineProps<{
    isVisible: boolean;
    source: ContentCalendarInputSource;
    biggestOrder: number;
  }>(),
  {}
);

const emit = defineEmits<{
  (e: "update:isVisible", isVisible: boolean): void;
  (e: "create", calendarInput: ContentCalendarInput): void;
}>();

// Create input ===============================================================
const isLoading = ref<boolean>(false);

const date = ref<string>("");
const title = ref<string>("");
const description = ref<string>("");

const orderIncreasingStep = 1024;

const createInputRequest = computed<CreateContentCalendarInputRequest>(() => {
  return {
    customerId: route.params.customerId,
    date: date.value,
    title: title.value,
    description: description.value,
    source: props.source,
    order: props.biggestOrder + orderIncreasingStep,
  };
});

async function createInput(closeModalCallback: Function) {
  isLoading.value = true;
  const calendarInput = await ContentCalendarRepo.createInput(createInputRequest.value.customerId, createInputRequest.value);
  isLoading.value = false;

  emit("create", calendarInput);

  closeModalCallback();
}
</script>
